/**
 * Single source of truth for Sentry opt-in (see src/utils/is-next-public-sentry-enabled.ts).
 */
export function isNextPublicSentryEnabled() {
  const v = process.env.NEXT_PUBLIC_ENABLE_SENTRY;
  if (!v) return false;
  const normalized = String(v).trim().toLowerCase();
  return normalized === '1' || normalized === 'true';
}
